/**
 * itprocessactions.js
 **/

import {
	API_RESOURCES,
	createApiReadAction,
	createApiCreateAction,
	createApiDeleteAction,
	createApiUpdateAction
} from '../../util/api';

import {
	GET_ALL_ITPROCESSES,
	UPDATE_ITPROCESS,
	GET_ALL_ITPROCESSES_WITHOUT_PAGINATION,
	CREATE_ITPROCESS,
	DELETE_ITPROCESS,
	UNRELATE_TASK_ITPROCESS,
	RELATE_TASK_ITPROCESS,
	ADD_RELATED_TASK,
	GET_ITPROCESS_BY_ID
} from '../actiontypes';

export const getAllItProcesses = (engagementId, args, filters) => {
	return createApiReadAction(
		GET_ALL_ITPROCESSES,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITPROCESSES]: undefined
		},
		filters,
		args
	);
};

export const getITProcessById = (engagementId, itProcessId, queryString) => {
	return createApiReadAction(
		GET_ITPROCESS_BY_ID,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITPROCESSES]: itProcessId
		},
		queryString
	);
};

export const createITProcess = (engagementId, data, bodyId) => {
	return createApiCreateAction(
		CREATE_ITPROCESS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITPROCESSES]: undefined
		},
		data,
		{bodyId, resolve: true}
	);
};

export const updateItProcess = (engagementId, data, entityUId) => {
	return createApiUpdateAction(
		UPDATE_ITPROCESS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITPROCESSES]: entityUId
		},
		data,
		undefined,
		{resolve: true}
	);
};

export const deleteItProcess = (engagementId, bodyId, itProcessId) => {
	return new createApiDeleteAction(
		DELETE_ITPROCESS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITPROCESSES]: itProcessId
		},
		{
			bodyId,
			itProcessId
		}
	);
};

export const getAllItProcessesWithoutPagination = (engagementId, args, filters) => {
	return createApiReadAction(
		GET_ALL_ITPROCESSES_WITHOUT_PAGINATION,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITPROCESSES]: undefined
		},
		filters,
		args
	);
};

export const relateTask = (engagementId, itProcessId, taskId, resolve = undefined) => {
	return createApiCreateAction(
		RELATE_TASK_ITPROCESS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: taskId,
			[API_RESOURCES.ITPROCESS]: undefined
		},
		itProcessId,
		{resolve: resolve}
	);
};

export const unrelateTask = (engagementId, itProcessId, taskId) => {
	return createApiDeleteAction(
		UNRELATE_TASK_ITPROCESS,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.TASKS]: taskId,
			[API_RESOURCES.ITPROCESS]: itProcessId
		},
		{
			itProcessId: itProcessId,
			taskId: taskId
		}
	);
};

export const addRelatedTask = (taskAttributes) => {
	return {
		type: ADD_RELATED_TASK,
		taskAttributes: taskAttributes
	};
};
